export default __webpack_public_path__ + "static/media/Empty_Notification.abe6dbc0.svg";